import Api from "../services/AxiosService";
import { unwrap } from "./envelope";

export interface Fastener {
  partNo: string;
  minSheetThickness: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface PaginatedFasteners {
  data: Fastener[];
  pagination: PaginationMeta;
}

export interface ListFastenersParams {
  page?: number;
  limit?: number;
  search?: string;
}

export interface CreateFastenerBody {
  partNo: string;
  minSheetThickness?: string | number | null;
}

export interface UpdateFastenerBody {
  minSheetThickness?: string | number | null;
}

export async function listFasteners(
  params: ListFastenersParams = {},
): Promise<PaginatedFasteners> {
  const res = await Api.get("/v1/fasteners", { params });
  return unwrap<PaginatedFasteners>(res.data);
}

export async function getFastener(partNo: string): Promise<Fastener> {
  const res = await Api.get(`/v1/fasteners/${encodeURIComponent(partNo)}`);
  return unwrap<Fastener>(res.data);
}

export async function createFastener(body: CreateFastenerBody): Promise<Fastener> {
  const res = await Api.post("/v1/fasteners", body);
  return unwrap<Fastener>(res.data);
}

export async function updateFastener(
  partNo: string,
  body: UpdateFastenerBody,
): Promise<Fastener> {
  const res = await Api.put(`/v1/fasteners/${encodeURIComponent(partNo)}`, body);
  return unwrap<Fastener>(res.data);
}

export async function deleteFastener(partNo: string): Promise<{ success: true }> {
  const res = await Api.delete(`/v1/fasteners/${encodeURIComponent(partNo)}`);
  return unwrap<{ success: true }>(res.data);
}
